import styled from 'styled-components';
import {media} from '../styles/breakpoints';

export default styled.span`
    font-size: 0.58em
    line-height: 1;
    
    ${media.wideScreenUp`font-size: 0.53em;`}
    ${media.tweak1600up`font-size: 0.53em;`}
    
`;



// WEBPACK FOOTER //
// ./src/components/styles/IconText.js